import { render, staticRenderFns } from "./cajasImagenes.vue?vue&type=template&id=496d4590&scoped=true&"
import script from "./cajasImagenes.vue?vue&type=script&lang=ts&"
export * from "./cajasImagenes.vue?vue&type=script&lang=ts&"
import style0 from "./cajasImagenes.vue?vue&type=style&index=0&id=496d4590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d4590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
